"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _userflow = require("../../utils/userflow");

var _excluded = ["value", "className"];

var HotelTrustYouScore = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var value = _ref.value,
      className = _ref.className,
      props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var resultValue = (0, _userflow.numberRestrictor)(value);
  return /*#__PURE__*/_react["default"].createElement(StyledHotelTrustYouScore, (0, _extends2["default"])({
    className: className,
    value: resultValue
  }, props), resultValue);
});

HotelTrustYouScore.displayName = 'HotelTrustYouScore';
HotelTrustYouScore.propTypes = {
  className: _propTypes["default"].string,
  value: _propTypes["default"].number.isRequired
};
HotelTrustYouScore.defaultProps = {
  className: ''
};

var StyledHotelTrustYouScore = _styledComponents["default"].span.withConfig({
  displayName: "HotelTrustYouScore__StyledHotelTrustYouScore",
  componentId: "sc-jc3fa5-0"
})(["", ""], function (_ref2) {
  var value = _ref2.value,
      theme = _ref2.theme;
  var color = theme.colors.greyLight;

  if (value >= 5 && value < 7) {
    color = theme.colors.blackLight;
  } else if (value >= 7 && value < 9) {
    color = '#28bd61';
  } else if (value >= 9) {
    // color = '#22b7af';
    color = '#0cb7b0';
  }

  return "color: ".concat(color, ";");
});

var _default = HotelTrustYouScore;
exports["default"] = _default;